module.exports = __webpack_public_path__ + "static/media/icon-opponent.9f809ef1.svg";